import { render } from "./InventoryPricing.vue?vue&type=template&id=44aa5764"
import script from "./InventoryPricing.vue?vue&type=script&lang=js"
export * from "./InventoryPricing.vue?vue&type=script&lang=js"

import "./InventoryPricing.vue?vue&type=style&index=0&id=44aa5764&scope=true&lang=css"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__